import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await api.get('/users/me', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setCurrentUser(response.data);

          // Fetch branding for opticians if not cached
          if (response.data.role === 'optician' && !localStorage.getItem('branding')) {
            try {
              const brandRes = await api.get(`/white-label/by-store/${response.data.id}`);
              if (brandRes.data) {
                localStorage.setItem('branding', JSON.stringify({
                  primaryColor: brandRes.data.primaryColor,
                  logoUrl: brandRes.data.logoUrl,
                  name: brandRes.data.name,
                  slug: brandRes.data.slug,
                }));
              }
            } catch {} // silently fail
          }
        } catch (error) {
          console.error('Failed to fetch user', error);
        }
      }
      setLoading(false);
    };

    checkAuth();
  }, []);

  const updateUser = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const response = await api.get('/users/me', {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCurrentUser(response.data);
      } catch (error) {
        console.error('Failed to update user', error);
      }
    }
  };

  const logout = async () => {
    try {
      const token = localStorage.getItem('token');
      if (token) {
        // Appeler l'API de déconnexion si nécessaire
        await api.post('/auth/logout', {}, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }).catch(() => {
          // Ignorer les erreurs de déconnexion de l'API
        });
      }
    } finally {
      // Toujours nettoyer le localStorage et l'état
      localStorage.removeItem('token');
      localStorage.removeItem('branding');
      setCurrentUser(null);
    }
  };

  const value = {
    currentUser,
    setCurrentUser,
    updateUser,
    logout,
    isAuthenticated: !!currentUser,
  };

  return <AuthContext.Provider value={value}>{!loading && children}</AuthContext.Provider>;
};
